import * as React from "react";

import * as coreActions from "@v1/actions/core-actions";
import { useEditorDispatch } from "@v1/store/store";

export default function useSetDraftElement() {
  const dispatch = useEditorDispatch();
  const setDraftElement = React.useCallback(
    (payload: coreActions.SetDraftElementPayload) => {
      return dispatch(coreActions.setDraftElement(payload));
    },
    [dispatch],
  );

  return setDraftElement;
}
